export const setHomeToken = (val) => {
    sessionStorage.setItem('homeToken', val)
}
export const getHomeToken = () => {
    return sessionStorage.getItem('homeToken')
}

const tokenManagerNameSpace = [
    'business',
    'sampleProject'
]

class TokenManagers {
    constructor() {
        this.currentNamespace = 'business';
        this.tokenPrefix = 'app_token_';
        this.memoryCache = new Map();
    }

    setToken(token, namespace = this.currentNamespace) {
        const encrypted = this._encrypt(token);
        sessionStorage.setItem(`${this.tokenPrefix}${namespace}`, encrypted);
        this.memoryCache.set(namespace, token);
    }

    getToken(namespace = this.currentNamespace) {
        if (!tokenManagerNameSpace.includes(namespace)) {
            return console.error('token namespace is not find');
        }
        if (this.memoryCache.has(namespace)) {
            return this.memoryCache.get(namespace);
        }

        const token = sessionStorage.getItem(`${this.tokenPrefix}${namespace}`);
        if (token) {
            const decrypted = this._decrypt(token);
            this.memoryCache.set(namespace, decrypted);
            return decrypted;
        }
        return null;
    }

    switchNamespace(namespace) {
        this.currentNamespace = namespace;
    }

    clearToken(namespace) {
        if (namespace) {
            sessionStorage.removeItem(`${this.tokenPrefix}${namespace}`);
            this.memoryCache.delete(namespace);
        } else {
            Object.keys(sessionStorage)
                .filter(k => k.startsWith(this.tokenPrefix))
                .forEach(k => {
                    sessionStorage.removeItem(k);
                    this.memoryCache.delete(k.replace(this.tokenPrefix, ''));
                });
        }
    }

    _encrypt(data) {
        return btoa(encodeURIComponent(data)); // 简单base64加密
    }

    _decrypt(data) {
        return decodeURIComponent(atob(data));
    }
}

export const TokenManager = new TokenManagers();